import { combineReducers } from 'redux';
import updateBidDetails from './updateBidDetails/reducer';
import customQueries from './customQueries/reducer';
import assignEntities from './assignEntities/reducer';
import updateOpenOrders from './updateopenorders/reducer';
import importExport from './importExport/reducer';
import assignOrderPreference from './assignorderpreference/reducer';
import printBarcode from './printBarcodes/reducer';
import zeroNegativeBalance from './zeroNegativeBalance/reducer';

export default combineReducers({
  updateBidDetails,
  assignEntities,
  customQueries,
  updateOpenOrders,
  importExport,
  assignOrderPreference,
  printBarcode,
  zeroNegativeBalance,
});



// WEBPACK FOOTER //
// ./src/pages/utilities/state/reducer.js